var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 7687",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 923",
    d: "M20 1.894a8.3 8.3 0 0 1-2.356.636A4.073 4.073 0 0 0 19.449.3a8.327 8.327 0 0 1-2.606.98 4.128 4.128 0 0 0-3-1.275 4.071 4.071 0 0 0-4.1 4.039 3.976 3.976 0 0 0 .106.921A11.711 11.711 0 0 1 1.393.738a3.967 3.967 0 0 0-.556 2.031 4.023 4.023 0 0 0 1.824 3.363A4.131 4.131 0 0 1 .8 5.626v.052a4.058 4.058 0 0 0 3.292 3.96 4.162 4.162 0 0 1-1.853.07 4.1 4.1 0 0 0 3.834 2.8 8.313 8.313 0 0 1-5.1 1.728A8.294 8.294 0 0 1 0 14.185 11.746 11.746 0 0 0 6.289 16a11.693 11.693 0 0 0 7.369-2.507 11.639 11.639 0 0 0 4.307-8.986c0-.175 0-.349-.012-.522A8.258 8.258 0 0 0 20 1.894zm0 0",
    transform: "translate(11 13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 71",
    style: {
      stroke: "#fff",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 19.75,
    style: {
      fill: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.575ac7d6883d1ee893a07419d9687c57.svg";
export { ForwardRef as ReactComponent };